import { Box, styled } from '@mui/material';

export const OverviewDetailBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  height: '95vh',
  maxWidth: '100%',
  borderRadius: '2px',
  overflowY: 'visible',
  flexDirection: 'column',
  padding: theme.spacing(1),
  boxShadow: theme.shadows[2],
  backgroundColor: theme.palette.background.paper,
}));

export const ItemListContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '2px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flexGrow: 2,
  height: '95vh',
  maxWidth: '80vw',
  padding: theme.spacing(2),
  overflow: 'auto',
  [theme.breakpoints.down('sm')]: {
    // marginTop: theme.spacing(2),
    height: '100%',
  },
}));
